export const programDict = {
  en: {
    learnMore: 'Learn more',
  },
  de: {
    learnMore: 'Mehr erfahren',
  },
  ru: {
    learnMore: 'Узнать подробнее',
  },
  tr: {
    learnMore: 'Daha fazla bilgi',
  },
};
